const content = {
  // LosFilterModal
  filterModal: {
    title: "Select a Filter",
    showInternationalFrontlinesOnly: "Show International Frontlines Only",
    showInMarketFrontlinesOnly: "Show In-Market Frontlines Only",
    showInternationalDownlines: "Show International Downlines",
    showData: "Show Data",
    showABOsWithZeroVolume: "Show ABOs With Zero Volume",
    cancel: "Cancel",
    apply: "Apply",
    close: "Close",
  },
  // LosToolbar
  toolbar: {
    searchPlaceholder: "Search",
    clearSearchAriaLabel: "Clear search",
    treeViewLabel: "Tree View",
    exportAriaLabel: "Export",
    undoDownlineLos: "Undo View Downline LOS",
    filtersAriaLabel: "Filters",
    filtersActiveAriaLabel: "Filters, {count} active",
  },
} as const;

export default content;
